import { css } from '@emotion/react';
import { ChartItemComponent } from './chartItem/chartItem.component';
import type { ChartItem } from './chartItem/chartItem.types';

const containerStyle = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 10,
});

type ChartsGalleryComponentProps = Readonly<{
  className?: string;
  chartItems: ReadonlyArray<ChartItem>;
}>;

export const ChartsGalleryComponent = ({
  className,
  chartItems,
}: ChartsGalleryComponentProps) => {

  return (
    <div className={className} css={containerStyle}>
      {chartItems.map((chartItem) => (
        <ChartItemComponent
          key={chartItem.id}
          {...chartItem}
        />
      ))}
    </div>
  );
};
